/**
 * MissionApiClient -- HTTP client for /api/v1/Missions.
 *
 * @module infrastructure/api/MissionApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Missions';

export const MissionApiClient = {
  /**
   * @param {number} page
   * @param {number} pageSize
   * @param {{ status?: string, priority?: string, sortBy?: string, sortOrder?: string }} [query]
   */
  async list(page = 1, pageSize = 20, query = {}) {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (query.status) params.set('status', query.status);
    if (query.priority) params.set('priority', query.priority);
    if (query.sortBy) params.set('sortBy', query.sortBy);
    if (query.sortOrder) params.set('sortOrder', query.sortOrder);
    return ApiBase.get(`${BASE}?${params}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async create(mission) {
    return ApiBase.post(BASE, mission);
  },

  async update(id, mission) {
    return ApiBase.put(`${BASE}/${id}`, mission);
  },

  async remove(id) {
    return ApiBase.del(`${BASE}/${id}`);
  }
};
